/* PeerHint — a reusable, family-warm note reminding players that AI
   pronunciation can be off, and inviting a family member, classmate, or
   teacher to step in. Shown under speaker buttons and on language hubs. */
import React from 'react';
import { Users2 } from 'lucide-react';

export default function PeerHint({ variant = 'inline', className = '' }) {
    if (variant === 'compact') {
        return (
            <p className={`text-xs text-lq-ink-500 inline-flex items-center gap-1 ${className}`} data-testid="peer-hint-compact">
                <Users2 size={12} className="text-lq-purple-500" />
                AI pronunciation can miss a tone — ask a family member, classmate, or teacher to play along.
            </p>
        );
    }
    return (
        <div className={`mt-3 flex gap-3 items-start p-3 rounded-xl bg-lq-purple-50 border border-lq-purple-100 ${className}`} data-testid="peer-hint">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-lq-purple-100 text-lq-purple-700 inline-flex items-center justify-center">
                <Users2 size={16} />
            </div>
            <div className="text-sm text-lq-ink-700 leading-snug">
                <strong className="text-lq-ink-900">Heritage sounds best shared.</strong>{' '}
                Our AI voice is a helper, not a teacher — it can mis-stress a syllable. Play together with a family member,
                a classmate, a friend, or a teacher and let them correct pronunciation. That's where real fluency grows.
            </div>
        </div>
    );
}
